(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mascara-mixed-bundle"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('painted-mascara-bundle')){
customElements.define('painted-mascara-bundle',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const data=this.querySelector('[data-bundle-variants]');if(!data)return;
  this.variants=JSON.parse(data.textContent);this.images=JSON.parse(this.querySelector('[data-bundle-images]').textContent);
  this.form=this.querySelector('form');this.button=this.querySelector('[data-bundle-submit]');
  this.addEventListener('change',()=>this.update());
  this.form.addEventListener('submit',e=>{if(!this.current?.available||this.dataset.purchase!=='true'){e.preventDefault();return;}this.button.disabled=true;this.button.setAttribute('aria-busy','true');});
  const urlVariant=new URL(location.href).searchParams.get('variant');
  const selected=this.variants.find(v=>String(v.id)===urlVariant)||this.variants.find(v=>v.options[0]==='Dolly Doll'&&v.options[1]==='Black'&&v.options[2]==='Picture Day')||this.variants[0];
  if(selected)this.querySelectorAll('[data-option-index]').forEach(group=>{group.querySelectorAll('input').forEach(input=>{input.checked=input.value===selected.options[Number(group.dataset.optionIndex)];});});
  this.update(false);
 }
 update(updateURL=true){
  const options=[];this.querySelectorAll('[data-option-index]').forEach(group=>{const selected=group.querySelector('input:checked');if(selected){options[Number(group.dataset.optionIndex)]=selected.value;group.querySelector('[data-selected-name]').textContent=selected.value;}});
  this.current=this.variants.find(v=>v.options.every((o,i)=>o===options[i]));
  const image=this.images[options.join('|')];if(image){const hero=this.querySelector('[data-bundle-image]');hero.src=image;hero.alt=options.join(' + ');}
  const allowed=this.current?.available&&this.dataset.purchase==='true';
  this.button.disabled=!allowed;
  this.querySelector('[data-variant-id]').value=this.current?.id||'';
  if(this.current){this.querySelector('[data-bundle-price]').textContent=this.current.price;if(updateURL){const url=new URL(location.href);url.searchParams.set('variant',this.current.id);history.replaceState({},'',url);}}
  this.querySelector('[data-button-label]').textContent=this.dataset.addLabel;
  this.querySelector('[data-bundle-status]').textContent='';
 }
});}

  } catch(e) { console.error(e); }
})();
})();
